// © 2026 Holmes Computer Consultants. All rights reserved. -- www.holmesconsultants.com
import nova from '../../machines/neon-nova/presentation.json'
import fathom from '../../machines/iron-fathom/presentation.json'
import pier from '../../machines/pier-carnival/presentation.json'
import surf from '../../machines/surf-rescue/presentation.json'
import dune from '../../machines/dune-circuit/presentation.json'
import starfall from '../../machines/starfall-salvage/presentation.json'
import fallback from '../../machines/default-lighting.json'

export type LightingShow = 'bank' | 'combo' | 'jackpot' | 'multiball'
export interface LightingProfile {
  readonly version: number
  readonly palette: { readonly idle: string; readonly active: string; readonly hit: string; readonly award: string }
  readonly modes: Readonly<Record<string, string>>
  readonly cues: Readonly<Record<string, LightingShow>>
  readonly paths?: Readonly<Record<string, string>>
  /** Backglass, ceiling, floor, left wall, right wall and front reflection panels. */
  readonly environment?: readonly string[]
  readonly rubber?: string
}
export const DEFAULT_LIGHTING_PROFILE: LightingProfile = fallback as LightingProfile
export const LIGHTING_PROFILES: Readonly<Record<string, LightingProfile>> = {
  'neon-nova': nova.lighting as LightingProfile, 'iron-fathom': fathom.lighting as LightingProfile,
  'pier-carnival': pier.lighting as LightingProfile, 'surf-rescue': surf.lighting as LightingProfile,
  'dune-circuit': dune.lighting as LightingProfile,
  'starfall-salvage': starfall.lighting as LightingProfile,
}
export function lightingProfileFor(id: string, insertColour?: string): LightingProfile {
  const known = Object.hasOwn(LIGHTING_PROFILES, id) ? LIGHTING_PROFILES[id] : undefined
  if (known !== undefined) return known
  return insertColour !== undefined && /^#[0-9a-f]{6}$/i.test(insertColour)
    ? { ...DEFAULT_LIGHTING_PROFILE, palette: { ...DEFAULT_LIGHTING_PROFILE.palette, active: insertColour } }
    : DEFAULT_LIGHTING_PROFILE
}
export function lightingRgb(hex: string): readonly [number, number, number] {
  const n = /^#[0-9a-f]{6}$/i.test(hex) ? Number.parseInt(hex.slice(1), 16) : 0xffe3b0
  return [(n >>> 16) / 255, ((n >>> 8) & 255) / 255, (n & 255) / 255]
}
